import { useState, useEffect } from 'react';
import baseURL from './url';

const STORAGE_KEY = 'dxn_site_config';

export function aplicarConfiguracionEnDOM(config) {
    if (!config) return;

    // Aplicar colores dinámicos como variables CSS en :root
    if (config.color_menu_movil) {
        document.documentElement.style.setProperty('--color-menu-movil', config.color_menu_movil);
        document.documentElement.style.setProperty('--color1', config.color_menu_movil);
        document.documentElement.style.setProperty('--color2', config.color_menu_movil);
        document.documentElement.style.setProperty('--loading', config.color_menu_movil + '77');
    }
    if (config.color_footer) {
        document.documentElement.style.setProperty('--color-footer', config.color_footer);
    }
    if (config.footer_bg_image) {
        document.documentElement.style.setProperty('--footer-bg-image', `url("${config.footer_bg_image}")`);
    } else {
        document.documentElement.style.setProperty('--footer-bg-image', 'none');
    }
    const footerOpacity = config.footer_bg_opacity !== undefined && config.footer_bg_opacity !== '' ? config.footer_bg_opacity : '0.70';
    document.documentElement.style.setProperty('--footer-bg-opacity', footerOpacity);


    // Aplicar Favicon dinámico en el <head>
    if (config.favicon) {
        let link = document.querySelector("link[rel*='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'shortcut icon';
            document.head.appendChild(link);
        }
        link.href = config.favicon;
    }
}

export function notificarCambioConfiguracion(nuevaConfig) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(nuevaConfig));
    } catch (e) {}
    aplicarConfiguracionEnDOM(nuevaConfig);
    window.dispatchEvent(new CustomEvent('dxn_site_config_updated', { detail: nuevaConfig }));
}

export default function useSiteConfig() {
    const [config, setConfig] = useState(() => {
        try {
            const cached = localStorage.getItem(STORAGE_KEY);
            if (cached) {
                const parsed = JSON.parse(cached);
                aplicarConfiguracionEnDOM(parsed);
                return parsed;
            }
        } catch (e) {}
        return {
            logo: '',
            favicon: '',
            color_menu_movil: '#3F1D76',
            color_footer: '#3F1D76',
            footer_bg_image: '',
            footer_bg_opacity: '0.70'
        };
    });

    useEffect(() => {
        // Cargar desde API
        fetch(`${baseURL}/configuracionGet.php`)
            .then(res => res.json())
            .then(data => {
                if (data && data.config) {
                    setConfig(data.config);
                    try {
                        localStorage.setItem(STORAGE_KEY, JSON.stringify(data.config));
                    } catch (e) {}
                    aplicarConfiguracionEnDOM(data.config);
                }
            })
            .catch(err => {
                console.warn('No se pudo obtener configuración en vivo:', err);
            });

        // Escuchar eventos locales de actualización (cuando se guarde en admin)
        const handleConfigUpdate = (e) => {
            if (e.detail) {
                setConfig(prev => ({ ...prev, ...e.detail }));
                aplicarConfiguracionEnDOM(e.detail);
            }
        };

        window.addEventListener('dxn_site_config_updated', handleConfigUpdate);
        return () => {
            window.removeEventListener('dxn_site_config_updated', handleConfigUpdate);
        };
    }, []);

    return {
        config,
        logo: config?.logo || '',
        favicon: config?.favicon || '',
        color_menu_movil: config?.color_menu_movil || '#3F1D76',
        color_footer: config?.color_footer || '#3F1D76',
        footer_bg_image: config?.footer_bg_image || '',
        footer_bg_opacity: config?.footer_bg_opacity !== undefined ? config.footer_bg_opacity : '0.70'
    };
}
